import React, { useState } from "react";
import Retesting_Testing_Form from "./retesting_Testing_Form/Replicate_Testing_Form";
import Retesting_Testing_table from "./retesting_Testing_table/Retesting_Testing_table";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Retesting_Testing({ validitydetails, setCurrentPage, currentPage ,openDeleteModal}) {
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                          
  const haveReadPermission = permissions?.includes(FixIDS.ensuring_the_validity.List);
  const haveAddPermission = permissions?.includes(FixIDS.retesting_testing.Add); //form


  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Retesting_Testing_Form
          validityTypeId={4}
          onProceed={() => setShowTable(true)}
        />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <Retesting_Testing_table
         openDeleteModal={openDeleteModal}
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          validityTypeId={4}
        /> }
      </div>
      {/* )} */}
    </>
  );
}

export default Retesting_Testing;
